import {Component, Input, OnInit} from '@angular/core';
import {ArticleService} from '@iw-shop/article/services/article.service';
import {Observable} from 'rxjs';
import {Customer} from '@iw-shop/customer/models/customer';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {take} from 'rxjs/operators';
import {getSelectedCustomer} from '@store/selectors/user.selector';

@Component({
    selector: 'iw-shop-article-price-basic',
    standalone: false,
    templateUrl: './article-price-basic.component.html',
    styleUrls: ['./article-price-basic.component.scss']
})
export class ArticleBasePriceComponent implements OnInit {
    @Input() netPrice?: number;
    @Input() unitOfMeasurement?: string;
    @Input() quantity?: number;
    @Input() unit?: number;
    @Input() taxRate?: number;

    customer$?: Observable<Customer | null | undefined>;
    customerPriceMode: 'net' | 'gross' = 'gross';

    constructor(public articleService: ArticleService, private store: Store<AppState>) {
        this.customer$ = this.store.select(getSelectedCustomer);

        this.customer$.pipe(
            take(1)
        )
            .subscribe(
                r => {
                    if (r?.priceMode) {
                        this.customerPriceMode = r.priceMode;
                    }
                }
            )
    }

    ngOnInit(): void {
    }

}
